import axios from "axios";

export const API = axios.create({
  baseURL: "https://easygrowthhelpadmin.apisky.live/",
  //baseURL: "http://localhost:5523/",
   // baseURL: "https://skybounty.vip/",
});
